/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomerPromotions200ResponseCustomerPromotionsInner } from './GetCustomerPromotions200ResponseCustomerPromotionsInner';
import {
    GetCustomerPromotions200ResponseCustomerPromotionsInnerFromJSON,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerFromJSONTyped,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerToJSON,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerToJSONTyped,
} from './GetCustomerPromotions200ResponseCustomerPromotionsInner';

/**
 * 
 * @export
 * @interface GetCustomerPromotions200Response
 */
export interface GetCustomerPromotions200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200Response
     */
    points: number;
    /**
     * 
     * @type {Array<GetCustomerPromotions200ResponseCustomerPromotionsInner>}
     * @memberof GetCustomerPromotions200Response
     */
    customerPromotions: Array<GetCustomerPromotions200ResponseCustomerPromotionsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200Response
     */
    customerUsedPromotions: Array<string>;
}

/**
 * Check if a given object implements the GetCustomerPromotions200Response interface.
 */
export function instanceOfGetCustomerPromotions200Response(value: object): value is GetCustomerPromotions200Response {
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('customerPromotions' in value) || value['customerPromotions'] === undefined) return false;
    if (!('customerUsedPromotions' in value) || value['customerUsedPromotions'] === undefined) return false;
    return true;
}

export function GetCustomerPromotions200ResponseFromJSON(json: any): GetCustomerPromotions200Response {
    return GetCustomerPromotions200ResponseFromJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPromotions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'points': json['points'],
        'customerPromotions': ((json['customerPromotions'] as Array<any>).map(GetCustomerPromotions200ResponseCustomerPromotionsInnerFromJSON)),
        'customerUsedPromotions': json['customerUsedPromotions'],
    };
}

export function GetCustomerPromotions200ResponseToJSON(json: any): GetCustomerPromotions200Response {
    return GetCustomerPromotions200ResponseToJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseToJSONTyped(value?: GetCustomerPromotions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'points': value['points'],
        'customerPromotions': ((value['customerPromotions'] as Array<any>).map(GetCustomerPromotions200ResponseCustomerPromotionsInnerToJSON)),
        'customerUsedPromotions': value['customerUsedPromotions'],
    };
}

